document.addEventListener("DOMContentLoaded", function () {
  function setCSSVariables() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        document.querySelector("header").getBoundingClientRect().bottom
      )}px`
    );
  }

  class CMMenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.openMenuButton = document.querySelector(
        '[data-action="open-drawer"]'
      );
      this.closeMenuButtons = document.querySelectorAll(
        '[data-action="close-drawer"]'
      );

      this.openMenuButton.addEventListener("click", this.openMenu.bind(this));
      this.closeMenuButtons.forEach((button) => {
        button.addEventListener("click", this.closeMenu.bind(this));
      });

      this.initSubmenus();
      this.initMegaMenu();
      this.initBackButton();
      this.initAccountMenu();
    }

    openMenu() {
      if (this.accountTrigger) {
        this.accountTrigger.classList.remove("is-open");
      }
      this.classList.add("active");
      document.body.classList.add("overflow-hidden-tablet");
      setCSSVariables();
    }

    closeMenu() {
      this.classList.remove("active");
      document.body.classList.remove("overflow-hidden-tablet");
      setCSSVariables();
      this.resetMenuState();
    }

    initSubmenus() {
      this.querySelectorAll("[data-toggle='submenu']").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.stopPropagation();

          let submenu = button.nextElementSibling;
          let isOpen = submenu.classList.contains("open");

          if (!isOpen) {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            submenu.classList.add("open");
          } else {
            submenu.style.maxHeight = "0px";
            submenu.classList.remove("open");
          }
        });
      });
    }

    initMegaMenu() {
      this.querySelectorAll(
        ".collections-list__item-link[data-menu-content]"
      ).forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();

          const menuContent = link.getAttribute("data-menu-content");
          const submenuContainer = document.querySelector(
            `.cm-header-drawer__submenu-products[data-menu-content="${menuContent}"]`
          );

          if (submenuContainer) {
            submenuContainer.classList.add("active");
            submenuContainer.style.transform = "translateX(0)";
            submenuContainer.style.zIndex = "10";
            submenuContainer.style.pointerEvents = "auto";
          }
        });
      });
    }

    initBackButton() {
      this.querySelectorAll(
        ".cm-header-drawer__submenu-products__back-button"
      ).forEach((button) => {
        button.addEventListener("click", () => {
          const parentContainer = button.closest(
            ".cm-header-drawer__submenu-products"
          );

          if (parentContainer) {
            parentContainer.classList.remove("active");
            parentContainer.style.transform = "translateX(100%)";
            parentContainer.style.zIndex = "-1";
          }
        });
      });
    }

    initAccountMenu() {
      this.accountTrigger = document.querySelector(".header__icon--account");
      if (!this.accountTrigger) return;

      this.accountTrigger.addEventListener("click", (event) => {
        if (
          event.target.closest(
            ".account-menu a, .account-menu summary, .account-menu button"
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const drawerWasOpen = this.classList.contains("active");
        if (drawerWasOpen) {
          this.closeMenu();
          this.accountTrigger.classList.add("is-open");
          return;
        }

        this.accountTrigger.classList.toggle("is-open");
      });

      document.addEventListener("click", (event) => {
        if (!this.accountTrigger.contains(event.target)) {
          this.accountTrigger.classList.remove("is-open");
        }
      });
    }

    resetMenuState() {
      this.querySelectorAll("[data-toggle='submenu']").forEach((button) => {
        let submenu = button.nextElementSibling;
        submenu.style.maxHeight = "0px";
        submenu.classList.remove("open");
      });

      this.querySelectorAll(".cm-header-drawer__submenu-products").forEach(
        (container) => {
          container.style.transform = "translateX(100%)";
          container.style.zIndex = "-1";
          container.classList.remove("active");
        }
      );
    }
  }

  customElements.define("cm-header-drawer", CMMenuDrawer);
});